import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { MotionConfig } from 'framer-motion'
import './styles/tokens.css'
import './styles/app.css'
import { App } from './App'
import { registreer } from './kiosk/offline'
import { startMeting } from './kiosk/meting'

/*
 * `reducedMotion="user"` laat elke motion-component de systeeminstelling volgen.
 * De kiosk zelf draait op een Chromium waar niemand die voorkeur zet, maar
 * framer-motion stuurt straks ook het attract-scherm en de beheerlaag — en dit
 * is het JS-equivalent van het @media-blok onderaan app.css, dat alleen de
 * CSS-transities dekt.
 */
// De service worker: bewaarde films en een kiosk die ook zonder netwerk start
// (PLAN.md §0.11).
registreer()
// De monitoring: waar bezoekers op tikken (docs/beheer.md).
startMeting()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <MotionConfig reducedMotion="user">
      <App />
    </MotionConfig>
  </StrictMode>,
)
